import {
  AppliedFiltersType,
  SelectedTagsType,
} from 'services/store/tags/types';
import { Song } from '../types';
import { Action, actionCreator } from '../../types';
import songsActionNames from './constants';
import type { GetSongsInfo, SongsSuccessInfo } from './types';

export const getSong = actionCreator<{ songId: string }>(
  songsActionNames.GET_SONG
);

export const getSongSuccess = actionCreator<{ song: Song }>(
  songsActionNames.GET_SONG_SUCCESS
);

export const getSongs = (
  page: number,
  selectedTags?: SelectedTagsType,

  appliedFilters?: AppliedFiltersType
): Action<GetSongsInfo> => ({
  type: songsActionNames.GET_SONGS,
  payload: {
    page,
    selectedTags: selectedTags ?? {},
    appliedFilters: appliedFilters ?? {},
  },
});

export const getSongsSuccess = actionCreator<SongsSuccessInfo>(
  songsActionNames.GET_SONGS_SUCCESS
);

export const resetSongs = actionCreator<void>(songsActionNames.RESET_SONGS);

export const setSongListPosition = actionCreator<{ position: number }>(
  songsActionNames.SET_SONG_LIST_POSITION
);
